<ng-container *ngIf="uploadsLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_UPLOADS'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="uploadsError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_UPLOADS'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="!uploadsLoading && !uploadsError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['MAINT_BTN_CREATE'] || 'Create New' }}"
				class="p-button-sm p-button-primary invisible-and-disabled" [disabled]="true"
				(click)="createNewRecord()"></button>


			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['MAINT_GLOBAL_SEARCH_PLACEHOLDER'] || 'Search' }}"
					class="p-inputtext-sm" />
			</span>
		</div>
		<p-table
			#dt 
			id = "tab_uploads"
			[globalFilterFields]="globalFilterFields" 
			[value]="uploads"
			[totalRecords] = "uploads.length"
			*ngIf="uploads && uploads.length > 0; else noUploads" styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
			responsiveLayout="scroll" [paginator]="true" 
			[rows]="getCurrentPageSize(0, uploads.length)"
			[rowsPerPageOptions]="setPaginator(uploads.length)"
			(onPage) = "onRowsPerPageChange($event, 0, uploads.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_UPLOADS'] }}"
			[tableStyle]="{'min-width': '88rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === uploads.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 6rem;">{{ translateServ.dictionary['MAINT_IN_TIT_ID'] }}</th>
					<th style="width: 8rem;">{{ translateServ.dictionary['MAINT_IN_TIT_CODE'] }}</th>
					<th style="width: 14rem;">{{ translateServ.dictionary['MAINT_IN_TIT_FOLD_NAME'] }}</th>
					<th style="width: 20rem;">{{ translateServ.dictionary['MAINT_IN_TIT_ORIG_FILE_NAME'] }}</th>
					<th style="width: 14rem;">{{ translateServ.dictionary['MAINT_IN_TIT_DOC_SUR'] }}</th>
					<th style="width: 12rem;">{{ translateServ.dictionary['MAINT_IN_TIT_DOC_TYPE'] }}</th>
					<th style="width: 12rem;">{{ translateServ.dictionary['MAINT_IN_TIT_DATE_ENT'] }}</th>
					<th style="width: 12rem;">{{ translateServ.dictionary['MAINT_IN_TIT_DATE_LUPD'] }}</th>
					<th style="width: 8rem;">{{ translateServ.dictionary['MAINT_IN_TIT_STAT'] }}</th>
					<th style="width: 10rem;">{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-uploadItem>
				<tr>
					<td class="wrap-cell">{{ uploadItem.RecID || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.Code || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.FolderName || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.OriginalFileName || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.DocSource || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.DocType || 'N/A' }}</td>
					<td class="wrap-cell">{{ uploadItem.DateEntered ? (uploadItem.DateEntered | date:'shortDate') :
						'N/A' }}</td>
					<td class="wrap-cell">{{ (uploadItem.DateUpdated ? (uploadItem.DateUpdated | date:'shortDate') :
						'N/A') }}</td>
					<td>
						<p-tag [value]="uploadItem.IsActive === 1 ? 'Active' : 'Inactive'"
							[severity]="getUploadSeverity(uploadItem.IsActive)" [rounded]="true"></p-tag>
					</td>
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-eye" (click)="viewUploadFile(uploadItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_VIEW_FILE'] || 'View File'"
								tooltipPosition="top"></button>
							<button pButton [icon]="uploadItem.IsActive === 1 ? 'pi pi-times' : 'pi pi-check'"
								(click)="toggleUploadStatus(uploadItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[ngClass]="uploadItem.IsActive === 1 ? 'p-button-danger' : 'p-button-success'"
								[pTooltip]="uploadItem.IsActive === 1 ? translateServ.dictionary['TOOLTIP_DEACTIVATE_USER'] : translateServ.dictionary['TOOLTIP_ACTIVATE_USER']"
								tooltipPosition="top"></button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noUploads>
		<div class="text-center p-4">
			<i class="pi pi-address-book text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_UPLOADS'] }}</p>
		</div>
	</ng-template>
</ng-container>

<p-dialog [header]="dialogHeader" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '80vw', height: '90vh' }"
	[draggable]="false" [resizable]="false" [maximizable]="true" (onHide)="onDialogHide()">
	<ng-container *ngIf="fileViewerUrl">
		<div class="file-viewer-content"
			style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
			<iframe *ngIf="fileContentType === 'pdf'" [src]="safeFileViewerUrl" frameborder="0" width="100%"
				height="100%" allowfullscreen></iframe>
			<img *ngIf="fileContentType === 'image'" [src]="safeFileViewerUrl"
				style="max-width: 100%; max-height: 100%; object-fit: contain;" alt="Uploaded Image" />
			<div *ngIf="fileContentType === 'unsupported'" class="text-center p-4">
				<i class="pi pi-file-excel text-400" style="font-size: 3rem;"></i>
				<p class="text-500 mt-3">
					{{ translateServ.dictionary['VIEWER_UNSUPPORTED_TYPE'] || 'This file type cannot be displayed
					directly in the viewer.' }}
				</p>
				<a [href]="fileViewerUrl" target="_blank" pButton icon="pi pi-download"
					label="{{ translateServ.dictionary['DOWNLOAD_FILE'] || 'Download File' }}"
					class="mt-3 p-button-outlined p-button-sm"></a>
			</div>
		</div>
	</ng-container>
	<ng-template pTemplate="footer">
		<p-button label="{{ translateServ.dictionary['CLOSE'] || 'Close' }}" icon="pi pi-times"
			(onClick)="displayDialog = false" styleClass="p-button-text"></p-button>
	</ng-template>
</p-dialog>